/**
 * The market block, fed from the window the page already has.
 *
 * It reads the same query as the ranking panel beside it, so the two share one
 * cached answer and one refresh. A second fetch here would double the traffic
 * for figures cut from the same pass.
 */
import { ErrorState, Forbidden, Loading } from "@/design-system/states/States";

import { MarketIntelligence } from "./MarketIntelligence";
import { useRanking } from "./useRanking";

export function MarketIntelligencePanel({
  testId,
}: {
  readonly testId?: string;
} = {}): React.JSX.Element {
  const state = useRanking();

  if (state.status === "loading") return <Loading title="Считываю рынок…" />;
  if (state.status === "forbidden") return <Forbidden />;
  if (state.status === "unreadable") {
    return (
      <ErrorState
        title="Не могу прочитать рынок"
        detail="Данные не пришли. Позиции и ордера на бирже от этого экрана не зависят."
      />
    );
  }

  // A window that has never been computed is a real state, not a failure: the
  // gauges say so themselves rather than being replaced by an error.
  return (
    <MarketIntelligence
      ranking={state.ranking.state === "NO_DATA_YET" ? null : state.ranking}
      {...(testId === undefined ? {} : { testId })}
    />
  );
}
